import { Navigate } from "react-router-dom";
import { ROUTE_RMS } from "./Routes";
// removed const {user} = useAuth(), due to race cases
export const RequireValidation = ({ children }) => {
  var _user = localStorage.getItem("user")
  if (typeof _user === 'undefined' || _user === null || _user === 'null'){
    return <Navigate to={ROUTE_RMS.withSlash} replace />;
  }
  return children;
};